import { FC } from "react";
import { Helmet } from "react-helmet";

interface IMeta {
  title?: any;
  keyword?: string;
  description?: string;
  image?: string;
  url?: string;
}

const MetaTags: FC<IMeta> = (props) => {
  const { title, description, keyword, image } = props;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="keyword" content={keyword} />
      <meta name="description" content={description} />
      <meta name="robots" content="noindex" />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:site" content="@publisher_handle" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:creator" content="@author_handle" />
      <meta name="twitter:image" content={image} />
      <meta property="og:title" content={title} />
      <meta property="og:type" content="article" />
      <meta property="og:url" content={process.env.REACT_APP_BASE_URL} />
      <meta
        property="og:image"
        content={`${process.env.REACT_APP_BASE_URL}/image.jpg`}
      />
      <meta property="og:description" content={description} />
      <meta itemProp="name" content={title} />
      <meta itemProp="description" content={description} />
      <meta
        itemProp="image"
        content={`${process.env.REACT_APP_BASE_URL}/image.jpg`}
      />
      <link rel="canonical" href={process.env.REACT_APP_BASE_URL} />
    </Helmet>
  );
};

export default MetaTags;
